// ** MUI Imports
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Type Import
import { Settings } from 'src/@core/context/settingsContext'

import { HeaderMobile } from './mobile/HeaderMobile'
import { HeaderDesktop } from './desktop/HeaderDesktop'
import { Accion } from '../../types'
import { EntityWithIdAndDescription } from 'src/types'
import { MensajeDetalle } from '@messages'

interface Props {
    hidden: boolean
    settings: Settings
    toggleNavVisibility: () => void
    acciones: {
        isNewOperacion: boolean
        saveHandler?: () => void
        closeHandler?: () => void
        printHandler?: () => void
        actionsOptions?: Accion[]
        actionsHandler: (seleccion: EntityWithIdAndDescription) => void
    }
    message: MensajeDetalle
}

const HeaderContent = ({ hidden, toggleNavVisibility, message, acciones }: Props) => {

    return (
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {
                hidden &&
                <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
                    {hidden ? (
                        <IconButton color='inherit' sx={{ ml: -2.75 }} onClick={toggleNavVisibility}>
                            <Icon icon='mdi:menu' />
                        </IconButton>
                    ) : null}
                </Box>
            }
            {
                hidden ?
                    <HeaderMobile message={message} acciones={acciones} /> :
                    <HeaderDesktop message={message} acciones={acciones} />
            }
        </Box>
    )
}

export default HeaderContent
